<div class="text-14">
	<pi-alert
		*ngIf="hasPortfolioDirtyFlag"
		[text]="AlertConstants.ALERT_DRAFT_DISABLED_TEXT | dcr: 'ALERT_DRAFT_DISABLED_TEXT'"
		[infoBubble]="AlertConstants.ALERT_DRAFT_DISABLED_INFO | dcr: 'ALERT_DRAFT_DISABLED_INFO'"
	>
	</pi-alert>
	<pi-alert
		*ngIf="isViewOnly"
		[text]="AlertConstants.ALERT_DRAFT_NOT_EDITABLE_TEXT | dcr: 'ALERT_DRAFT_NOT_EDITABLE_TEXT'"
		[infoBubble]="AlertConstants.ALERT_DRAFT_NOT_EDITABLE_INFO | dcr: 'ALERT_DRAFT_NOT_EDITABLE_INFO'"
	>
	</pi-alert>
</div>
